import ptBR from './locales/pt-br';
import enUS from './locales/en-us';
import esES from './locales/es-es';

export default {
    ptBR,
    enUS,
    esES
}